module.exports = new __parcel__URL__("arrow-up-right.ef218568.svg").toString();